import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { QueryConfig } from '@/lib/tanstack-query';
import { Group } from '@/types/api/group';

export const getGroup = async ({ groupId }: { groupId: string }): Promise<Group> => {
  return (await api.get(`/groups/${groupId}`)).data;
};

export const getGroupQueryOptions = (groupId: string) => {
  return queryOptions({
    queryKey: ['groups', groupId],
    queryFn: () => getGroup({ groupId }),
    enabled: Boolean(groupId),
  });
};

type UseGroupOptions = {
  groupId: string;
  queryConfig?: QueryConfig<typeof getGroupQueryOptions>;
};

export const useGroup = ({ groupId, queryConfig }: UseGroupOptions) => {
  return useQuery({
    ...getGroupQueryOptions(groupId),
    ...queryConfig,
  });
};

export const useGroupSuspense = ({ groupId, queryConfig }: UseGroupOptions) => {
  return useSuspenseQuery({
    ...getGroupQueryOptions(groupId),
    ...queryConfig,
  });
};
